export class LocalString {
    Key: string;
    Value: string;
}
